/*
 * @Author: 暮安 14122148+muanananan@user.noreply.gitee.com
 * @Date: 2024-03-04 10:34:47
 * @LastEditors: st 2946594574@qq.com
 * @LastEditTime: 2024-05-06 14:51:48
 * @FilePath: \vue-admin-template\src\permission.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import router from './router'
import store from './store'
// import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth'
import getPageTitle from '@/utils/get-page-title'
import { canAccessPage, getUserRedirectPath } from '@/utils/userStatus'
import { ensureEnabledFeatures, getCourseTypeCodeFromContext, hasFeature } from '@/utils/feature'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

// const whiteList = ['/login']

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  console.log('=== 路由守卫开始 ===')
  console.log('路由守卫 - 目标路径:', to.path, '来源路径:', from.path)

  // 白名单路径，不需要检查（包含忘记密码页面、联系我们页面）
  const whiteList = ['/', '/login', '/register', '/forgot-password', '/unit-info', '/course-required', '/contact', '/sms-test', '/app-download']
  console.log('路由守卫 - 白名单:', whiteList)
  console.log('路由守卫 - 检查是否在白名单:', whiteList.includes(to.path))

  if (whiteList.includes(to.path) || to.path.startsWith('/intro/')) {
    console.log('✅ 白名单路径，直接通过:', to.path)
    next()
    NProgress.done()
    return
  }

  // 检查用户是否已登录
  const userInfo = localStorage.getItem('userInfo')
  const token = getToken() // 从Cookie中获取token

  console.log('路由守卫 - 用户信息:', userInfo ? '存在' : '不存在', 'Token:', token ? '存在' : '不存在')

  if (!userInfo || !token) {
    // 未登录，跳转到登录页
    console.log('未登录，跳转到登录页')
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }

  // 如果是新窗口打开，等待一下确保localStorage和Cookie都加载完成
  if (window.opener) {
    console.log('检测到新窗口，等待认证信息加载...')
    console.log('新窗口目标路径:', to.path)
    console.log('新窗口URL:', window.location.href)

    // 给新窗口一点时间加载认证信息
    setTimeout(() => {
      const retryUserInfo = localStorage.getItem('userInfo')
      const retryToken = getToken()
      console.log('重试 - 用户信息:', retryUserInfo ? '存在' : '不存在', 'Token:', retryToken ? '存在' : '不存在')
      console.log('重试 - 用户信息内容:', retryUserInfo)
      console.log('重试 - Token内容:', retryToken ? retryToken.substring(0, 20) + '...' : 'null')

      if (!retryUserInfo || !retryToken) {
        console.log('新窗口认证信息加载失败，跳转到登录页')
        next({ path: '/login', query: { redirect: to.fullPath } })
        return
      }

      // 继续执行权限检查
      continuePermissionCheck()
    }, 500) // 增加等待时间到500ms
    return
  }

  // 继续执行权限检查
  continuePermissionCheck()

  async function continuePermissionCheck() {
    try {
      const currentUserInfo = localStorage.getItem('userInfo')
      const currentToken = getToken()

      if (!currentUserInfo || !currentToken) {
        console.log('权限检查 - 认证信息不存在，跳转到登录页')
        next({ path: '/login', query: { redirect: to.fullPath } })
        return
      }

      const user = JSON.parse(currentUserInfo)
      console.log('路由守卫 - 解析用户信息:', user)
      console.log('路由守卫 - 用户角色ID:', user.roleId, '用户标记:', user.mark)

      // 已登录用户访问 /dashboard 时：按角色/状态跳转到各自主页
      if (to.path === '/dashboard') {
        const homePath = getUserRedirectPath(user)
        if (homePath && homePath !== to.path) {
          console.log('路由守卫 - 默认首页重定向到用户主页:', homePath)
          next(homePath)
          return
        }
      }

      // AMC 流程页面：直接放行（避免被课程选课拦截）
      if ((to.meta && to.meta.amc === true) || to.path.startsWith('/amc-')) {
        console.log('AMC 流程页面放行:', to.path)
        next()
        return
      }

      // 袋鼠数学流程页面：直接放行（避免被课程选课拦截）
      if (to.path.startsWith('/kangaroo-')) {
        console.log('Kangaroo 流程页面放行:', to.path)
        next()
        return
      }

      // GESP 流程页面：直接放行（避免被课程选课拦截）
      if (to.path.startsWith('/gesp-')) {
        console.log('GESP 流程页面放行:', to.path)
        next()
        return
      }

      // 使用工具函数检查用户是否可以访问页面
      const canAccess = canAccessPage(user, to.path)
      console.log('路由守卫 - 是否可以访问:', canAccess, '路径:', to.path)

      if (!canAccess) {
        // 用户不能访问当前页面，重定向到应该去的页面
        const redirectPath = getUserRedirectPath(user)
        console.log('路由守卫 - 重定向到:', redirectPath)
        // 避免无限重定向：如果重定向路径与当前路径相同，直接跳转
        if (redirectPath === to.path) {
          console.log('路由守卫 - 避免无限重定向，直接通过')
          next()
          return
        }
        next(redirectPath)
        return
      }

      // 用户状态正常，继续访问
      console.log('路由守卫 - 用户状态正常，允许访问:', to.path)

      // 功能开关（默认全关）：如果路由定义了 meta.featureCode，则需要校验当前课程类型下是否启用
      if (to.meta && to.meta.featureCode) {
        try {
          const ct = getCourseTypeCodeFromContext(to)
          await ensureEnabledFeatures(ct)
          if (!hasFeature(to.meta.featureCode, ct)) {
            console.log('路由守卫 - 功能未启用，拦截:', to.meta.featureCode, 'courseTypeCode=', ct)
            next('/404')
            return
          }
        } catch (e) {
          console.error('路由守卫 - 功能开关校验失败:', e)
          next('/404')
          return
        }
      }

      // 特殊处理课程详情页面
      if (to.path.startsWith('/course/detail/')) {
        console.log('路由守卫 - 课程详情页面，直接通过')
        next()
        return
      }

      // 确保访问主页时侧边栏显示
      if (to.path === '/dashboard') {
        console.log('路由守卫 - 访问主页，确保侧边栏显示')
        store.dispatch('app/openSideBar', { withoutAnimation: false })
      }

      if (to.path !== '/') {
        store.commit('menu/ADD_TAG', {
          path: to.path,
          checked: false,
          title: to.meta.title
        })
      }
      next()
    } catch (error) {
      console.error('权限检查错误:', error)
      next({ path: '/login', query: { redirect: to.fullPath } })
    }
  }

  //   if (hasToken) {
  //     if (to.path === '/login') {
  //       // if is logged in, redirect to the home page
  //       next({ path: '/' })
  //       NProgress.done()
  //     } else {
  //       const hasGetUserInfo = store.getters.name
  //       if (hasGetUserInfo) {
  //         next()
  //       } else {
  //         try {
  //           // get user info
  //           await store.dispatch('user/getInfo')

  //           next()
  //         } catch (error) {
  //           // remove token and go to login page to re-login
  //           await store.dispatch('user/resetToken')
  //           Message.error(error || 'Has Error')
  //           next(`/login?redirect=${to.path}`)
  //           NProgress.done()
  //         }
  //       }
  //     }
  //   } else {
  //     /* has no token*/

  //     if (whiteList.indexOf(to.path)  != -1) {
  //       // in the free login whitelist, go directly
  //       next()
  //     } else {
  //       // other pages that do not have permission to access are redirected to the login page.
  //       next(`/login?redirect=${to.path}`)
  //       NProgress.done()
  //     }
  //   }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
